import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import NurturingTomorrowsLeaders from "./sections/NurturingTomorrowsLeaders";
import TheCgkAdvantage from "./sections/TheCgkAdvantage";
import ImpactInNumbers from "./sections/ImpactInNumbers";
import ElevateYourApplication from "./sections/ElevateYourApplication";
import GlobalSuccessStories from "./sections/GlobalSuccessStories";
import ReadyToStartTheConversation from "./sections/ReadyToStartTheConversation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <NurturingTomorrowsLeaders />
      <TheCgkAdvantage />
      <ImpactInNumbers />
      <ElevateYourApplication />
      <GlobalSuccessStories />
      <ReadyToStartTheConversation />
      <Footer />
    </div>;
}